import * as React from 'react'
import { faTimes } from '@fortawesome/pro-regular-svg-icons'
import { mtc } from '@/styles'
import { Icon } from '../icon'
import { cardStyles, iconStyles } from './styles'

export enum CardColors {
  LEVEL_0_NO_BORDER = 'level0_no_border',
  LEVEL_0 = 'level0',
  LEVEL_1 = 'level1',
  LEVEL_2 = 'level2',
  PRIORITY = 'priority',
  EMPHASIS = 'emphasis',
  BRAND = 'brand',
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
  GREEN = 'green',
  BLUE_GRADIENT = 'blueGradient',
  YELLOW_GRADIENT = 'yellowGradient',
  GREEN_GRADIENT = 'greenGradient',
}

interface ICardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
  color?: CardColors
  className?: string
  dismissible?: boolean
  onClose?: () => void
  permanentDismissalKey?: string
  childrenClassName?: string
}

export const Card = React.forwardRef<HTMLDivElement, ICardProps>(
  (
    {
      children,
      className,
      color,
      onClose = () => {},
      dismissible = false,
      permanentDismissalKey,
      childrenClassName,
      ...props
    },
    ref
  ) => {
    const [visible, setVisible] = React.useState(
      permanentDismissalKey
        ? !localStorage.getItem(permanentDismissalKey)
        : true
    )

    const handleClose = () => {
      setVisible(false)

      if (permanentDismissalKey) {
        localStorage.setItem(permanentDismissalKey, 'true')
      }

      onClose()
    }

    if (!visible) return null

    return (
      <div
        ref={ref}
        className={mtc(cardStyles({ color }), className)}
        {...props}
      >
        {dismissible && (
          <Icon
            backgroundClassName={mtc(iconStyles())}
            color="text-neutral-500"
            icon={faTimes}
            id="dismiss-icon"
            onClick={handleClose}
          />
        )}
        <div className={mtc('p-6', childrenClassName)}>{children}</div>
      </div>
    )
  }
)

Card.displayName = 'Card'
